module.exports = __webpack_public_path__ + "media/images/vehicles/baumaschienen-19adae05de97d95377a94cae940eea85.png";